import { message, Modal } from "antd";
import { useTranslation } from "react-i18next";
import {
  useAddTypesOfPesticidesMutation, useDeleteTypesOfPesticidesMutation, useEditTypesOfPesticidesMutation
} from "../../../../../redux/api/handBooksApi/chemicalization/typesOfPesticides";
import { EntDirectoryInfoName } from "../../../../../models/directoryInfoName";
import { getCookie } from "typescript-cookie";

const useTypesOfPesticides = (modal: any, refresh?: () => void) => {
  const { t } = useTranslation()
  const { confirm } = modal;
  const [addTypesOfPesticides] = useAddTypesOfPesticidesMutation();
  const [deleteTypesOfPesticides] = useDeleteTypesOfPesticidesMutation();
  const [editTypesOfPesticides] = useEditTypesOfPesticidesMutation();


  async function onAddTypesOfPesticides(newTypesOfPesticides: EntDirectoryInfoName): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await addTypesOfPesticides(newTypesOfPesticides).then((response: any) => {
		if (response.error) {
		  const isKyrgyz = getCookie('i18next') === 'ky';
		  const lang = isKyrgyz ? 'kg' : 'ru';
		  const res = response.error.data?.res;
		  const errorMessages = Array.isArray(res)
			? res.map((error: any) => error[lang] || error.ru).join('\n')
			: response.error.data?.msg || t('unknownError');
		  throw new Error(errorMessages);
		}
		if (response.data.success) {
		  status = true;
		  message.success(t('msg.successAdd'));
		  if(refresh) refresh();
		}
	  }).catch((error:any) => {
		modal.error({ title: t('msg.error'), content: String(error.message) });

	  });
	  return status;
	} catch (error: any) {
	  modal.error({ title: t('msg.error'), content: String(error.message) });
	  return false;
	}
  }

  async function onDeleteTypesOfPesticides(typesOfPesticides: EntDirectoryInfoName) {
	try {
	  let status: boolean = false;
	  confirm({
		centered: true,
		title: t('msg.confirmDeleteText'),
		okText: t('general.yes'),
		cancelText: t('general.no'),
		onOk() {
		  deleteTypesOfPesticides(typesOfPesticides.id as number).then((response: any) => {
			if (response.error) {
			  const isKyrgyz = getCookie('i18next') === 'ky';
			  const lang = isKyrgyz ? 'kg' : 'ru';
			  const res = response.error.data?.res;
			  const errorMessages = Array.isArray(res)
				? res.map((error: any) => error[lang] || error.ru).join('\n')
				: response.error.data?.msg || t('unknownError');
			  throw new Error(errorMessages);
			}
			if (response.data.success) {
			  status = true;
			  Modal.success({title: t('msg.successDelete')});
			  if(refresh) refresh();
			}
		  }).catch((error: any) => {
			Modal.error({ title: t('msg.error'), content: String(error.message) });

		  });
		}
	  })
	  return status
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };

  async function onEditTypesOfPesticides(editedTypesOfPesticides: EntDirectoryInfoName): Promise<boolean> {
	try {
	  let status: boolean = false;
	  await editTypesOfPesticides(editedTypesOfPesticides).then((response: any) => {
		if (response.error) {
		  const isKyrgyz = getCookie('i18next') === 'ky';
		  const lang = isKyrgyz ? 'kg' : 'ru';
		  const res = response.error.data?.res;
		  const errorMessages = Array.isArray(res)
			? res.map((error: any) => error[lang] || error.ru).join('\n')
			: response.error.data?.msg || t('unknownError');
		  throw new Error(errorMessages);
		}
		if (response.data.success) {
		  status = true;
		  Modal.success({title: t('msg.successEdited')});
		  if(refresh) refresh();
		}
	  }).catch((error: any) => {
		Modal.error({ title: t('msg.error'), content: String(error.message) });
	  });
	  return status;
	} catch (error: any) {
	  Modal.error({ title: t("msg.error"), content: String(error.message) });
	  return false;
	}
  };
  return { onAddTypesOfPesticides, onDeleteTypesOfPesticides, onEditTypesOfPesticides };

}
export { useTypesOfPesticides };

